import styled from '@emotion/styled';
import { Alert } from '@lightspeed/flame/Alert';
import { Button } from '@lightspeed/flame/Button';

export const ResponsiveTable = styled.table`
  @media (max-width: 855px) {
    tr {
      display: flex;
      flex-direction: column;
    }

    td:not(:last-child) {
      border-bottom: none;
    }

    td {
      display: flex;
      padding-left: 8px !important;
    }
  }
`;

export const CreditAccountSectionButton = styled(Button)`
  height: 36px;
  padding: 9px 13px;
  font-size: 14px;
  font-weight: 400;
`;

export const InTransitBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 400;
  color: #595959;
  background-color: #f0f0f0;
  border-radius: 4px;
  padding: 2px 8px;
  white-space: nowrap;
`;

export const CreditAccountUnavailableAlert = styled(Alert)`
  border-top: none;
  border-radius: 0;
  padding-top: 16px;
  padding-bottom: 16px;
`;
